import IconSvg from './assets/avatars/customer-avatar-business.svg';
import { FC } from 'react';

interface IconProps {
  width?: string | number;
  height?: string | number;
}

const Icon: FC<IconProps> = ({ width = 'auto', height = 'auto' }) => (
  <img alt="CustomerAvatarBusiness" src={IconSvg} width={width} height={height} />
);

export default Icon;
